import { RouterProvider } from 'react-router-dom';
import { AppProviders } from '@app/components/AppProviders';
import ErrorPortal from '@app/components/ErrorPortal';
import './styles.scss';
const App = ({ router }) => {
    return (<AppProviders>
            <RouterProvider router={router}/>
            <ErrorPortal />
        </AppProviders>);
};
export default App;
